import { Dialog, DialogContent } from '@/components/core/Dialog';

interface PreviewDialogProps {
    url: string;
    onClose: () => void;
}

const PreviewDialog = ({ onClose, url }: PreviewDialogProps) =>
    <Dialog open={true} onOpenChange={onClose}>
        <DialogContent>
            <div className="tw-flex tw-items-center tw-justify-center tw-h-[80vh] tw-p-5">
                <img src={url} className="tw-object-contain tw-w-full tw-h-full" />
            </div>
        </DialogContent>
    </Dialog>;

export { PreviewDialog };
